import type Luminary from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import { getEditableSceneText, getSceneGroupCategory } from 'js/src/luminary';

/**
 * Returns the script for the video as a string.
 * The script is a delimited (newline by default) list of text representing scene groups. The specifics depend on the
 * scene group category:
 * - CATEGORY_ORDINARY: the text value of all scenes in the group (separated by delimiter)
 * - CATEGORY_TALKING_HEAD: newline separated list of caption text
 * - CATEGORY_TALKING_HEAD_INSERT: left out of the script
 * - CATEGORY_VOICEOVER: same as CATEGORY_TALKING_HEAD
 * - CATEGORY_COMMON: same as CATEGORY_ORDINARY (once we have common scenes)
 * - CATEGORY_OUTRO: left out of the script
 * - CATEGORY_BRAND: left out of the script
 */
export function parseScript(luminary: Readonly<Luminary>, scene_delimiter = '\n'): string {
    let script = '';
    luminary.sceneGroups.forEach((sceneGroup) => {
        const sceneGroupCategory = getSceneGroupCategory(sceneGroup);
        switch (sceneGroupCategory) {
            case VideoData.CATEGORY_ORDINARY:
                script +=
                    sceneGroup.scenes
                        .map((scene) => getEditableSceneText(scene))
                        .join(scene_delimiter) + scene_delimiter;
                break;
            case VideoData.CATEGORY_TALKING_HEAD:
            case VideoData.CATEGORY_VOICEOVER:
                script +=
                    sceneGroup.scenes
                        .map((scene) => scene.extractTranscript().text)
                        .join(scene_delimiter) + scene_delimiter;
                break;
            case VideoData.CATEGORY_TALKING_HEAD_INSERT:
            case VideoData.CATEGORY_OUTRO:
            case VideoData.CATEGORY_BRAND:
                // skip
                break;
            default:
                throw new Error(`Unknown scene group category: ${sceneGroupCategory}`);
        }
    });
    return script.trim();
}
